import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalComponent } from './global/global.component';

interface SystemStatus {
  isServerDown: boolean;
  maintenanceStartUtc?: string;
  maintenanceEndUtc?: string;
  reason?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private systemStatus: SystemStatus = {
    isServerDown: false,
     maintenanceStartUtc: '2026-03-12T08:00:00Z',
    maintenanceEndUtc: '2026-03-12T09:30:00Z',
    reason: 'Scheduled maintenance'
  };

  constructor(private router: Router , public global: GlobalComponent,) {}

  private isSystemDown(): { isDown: boolean; reason: string } {
    if (this.systemStatus?.isServerDown) {
      return {
        isDown: true,
        reason: this.systemStatus?.reason || 'Server is temporarily unavailable'
      };
    }

    if (this.systemStatus?.maintenanceStartUtc && this.systemStatus?.maintenanceEndUtc) {
      const maintenanceStart = new Date(this.systemStatus.maintenanceStartUtc);
      const maintenanceEnd = new Date(this.systemStatus.maintenanceEndUtc);
      const now = new Date();

      if (now >= maintenanceStart && now <= maintenanceEnd) {
        return {
          isDown: true,
          reason: 'System is under maintenance. Please try again later.'
        };
      }
    }

    return { isDown: false, reason: '' };
  }

  public setSystemStatus(status: SystemStatus): void {
    this.systemStatus = { ...this.systemStatus, ...status };
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const routePath = state?.url;
      console.log(routePath,"routePath")
      if (routePath === '/app-maintenance') {
        return true;
      }
      const systemStatus = this.isSystemDown();
      if (systemStatus.isDown) {
        this.router.navigate(['/app-maintenance'], {
        state: { reason: systemStatus?.reason, maintenanceEnd: this.systemStatus?.maintenanceEndUtc }
      });
        return false;
      }

      const menus = JSON.parse(localStorage.getItem('CFSS_sidebars') || '[]'); 
      const allowedLinks = this.getAllowedLinks(menus);
      let isLoggedIn = this.global?.authtoken;
      if (allowedLinks.includes(routePath)) {
        if ( isLoggedIn == null && isLoggedIn == undefined &&  isLoggedIn == ""  )
          this.router.navigate(["/login"]);
        return true;
      }
      this.router.navigate(['/unauthorized'], { replaceUrl: true });
      return false;
  }
  private getAllowedLinks(menus: any[]): string[] {
    const links: string[] = [];

    menus.forEach((menu) => {
      if (menu.link) {
        links.push(menu.link);
      }
      if (menu.children && Array.isArray(menu.children)) {
        links.push(...this.getAllowedLinks(menu.children));
      }
    });
    if(links.includes("/Client")){
      links.push('/qp-info');
      links.push('/client-reports')
    }
    return links;
  }
  
}
